import * as React from "react";
import { Modal } from "@linkfluence/core/modal";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import ModalQueriesInfos from "./modal";

const MODAL_QUERIES_INFO = "modalQueriesInfo";

type openFn = (focus: number) => void;

interface IProps {
  children: (open: openFn) => JSX.Element;
}

const RadarlyModalQueriesDetails = ({ children }: IProps) => {
  const project = useCurrentProject();
  const [focus, setFocus] = React.useState(0);
  const locale = useCurrentUserLocale();
  const { open, close, ModalWrapper } = Modal.get(MODAL_QUERIES_INFO);
  return (
    <>
      {children((focus) => {
        setFocus(focus);
        open();
      })}
      <ModalWrapper>
        <ModalQueriesInfos
          project={project}
          focus={focus}
          locale={locale}
          close={() => close()}
        />
      </ModalWrapper>
    </>
  );
};

export default RadarlyModalQueriesDetails;
